<template lang="pug">
.bloco-dados-car-vinculados-monitoramento-agricola
    .bloco-dados-territorio--interno
        el-table.estilizacao-tabela(
            :data='cars.slice(0, 2)',
            height='100%',
            style='width: 100%'
        )
            el-table-column(label='CAR', min-width='300px')
                template.teste(slot-scope='scope')
                    span {{ scope.row.codigo }}
            el-table-column(:label="$t('mensagens.comuns.monitoramento.situacaoCAR')", width='150px')
                template.teste(slot-scope='scope')
                    span.condicao-ativo(v-if='scope.row.condicao === "AT"') {{ validaSituacao(scope.row.condicao) }}
                    span.condicao-pendente(
                        v-else-if='scope.row.condicao === "PE"'
                    ) {{ validaSituacao(scope.row.condicao) }}
                    span.condicao-suspenso(
                        v-else-if='scope.row.condicao === "SU"'
                    ) {{ validaSituacao(scope.row.condicao) }}
                    span.condicao-cancelado(v-else) {{ validaSituacao(scope.row.condicao) }}
                    el-tooltip(
                        class='item',
                        effect='dark',
                        placement='top-end')
                        div(slot='content')
                            span {{ $t('mensagens.monitoramentoAgricola.blocoCarsVinculados.statusAnterior') }} {{ validaSituacao(scope.row.statusAnterior) }}
                            br
                            span {{ $t('mensagens.monitoramentoAgricola.blocoCarsVinculados.ultimaAtualizacao') }} {{ scope.row.dataUltimaAtualizacao }}
                        i.ml-3.flow.flow-warning-sign.laranja(v-if="scope.row.statusAnterior")
        .tabela-rodape
            .tabela-rodape--esquerda
                p
                    span {{ $t('mensagens.blocoCarsVinculados.totalDeCars') }} &nbsp;
                        span {{ cars.length }}
            .tabela-rodape--centralizado
                p
                    span {{ $t('mensagens.blocoCarsVinculados.alertasIdentificados') }} &nbsp;
                        span {{ monitoramento.totalAlertasCARs }}
            .tabela-rodape--direita
                .abrindo-modal-cars(@click='abreModalCarsVinculados')
                    span.color-inforacao {{ $t('mensagens.comuns.verTodos') }}
                        i.el-icon-right.color-inforacao

    ModalVisualizacaoCarsVinnculadosMonitoramentoAgricola(
        v-if='showCarsVinculadosAgricola',
        :showCarsVinculadosAgricola='showCarsVinculadosAgricola',
        :cars='this.cars',
        :monitoramento='this.monitoramento'
    )
</template>
<script>
import ModalVisualizacaoCarsVinnculadosMonitoramentoAgricola from '@/components/monitoramento/ModalVisualizacaoCarsVinculadosMonitoramentoAgricola.vue';
import { mapActions, mapGetters } from 'vuex';
import StatusCar from '@/constants/StatusCar';

export default {
    name: 'BlocoDadosCarVinculadosMonitoramentoAgricola',
    components: {
        ModalVisualizacaoCarsVinnculadosMonitoramentoAgricola
    },
    props: {
        cars: {
            type: Array,
            required: true,
            default: null
        },
        monitoramento: {
            type: Object,
            required: true,
            default: null
        }
    },

    computed: {
        ...mapGetters(['showCarsVinculadosAgricola'])
    },

    methods: {
        ...mapActions(['changeShowCarsVinculadosAgricolaModal']),

        validaSituacao(situacao) {
            return StatusCar[situacao];
        },

        abreModalCarsVinculados() {
            this.changeShowCarsVinculadosAgricolaModal();
        }
    }
};
</script>
<style lang="scss" scoped>
.bloco-dados-car-vinculados-monitoramento-agricola {
    height: 232px;
    border-radius: 8px;
    background: var(--white);
    display: flex;
    justify-content: flex-start;
    padding: 7px 15px;
    color: var(--primary);

    .bloco-dados-territorio--interno {
        display: flex;
        position: relative;
        width: -webkit-fill-available;

        .estilizacao-tabela {
            height: 100%;
            width: 100%;
            border-bottom: 0px;
            overflow-x: auto;

            .el-table--enable-row-transition .el-table__body td.el-table__cell {
                -webkit-transition: background-color 0.25s ease;
                transition: background-color 0.25s ease;
                border-bottom: hidden !important;
                /* border-top: hidden !important; */
            }
        }
        .bloco-dados-territorio--interno--texto {
            display: flex;
            flex-direction: row;
            min-height: 58px;
            margin-left: 12px;

            span {
                margin-top: 6px;
            }
        }
    }
}

.tabela-rodape {
    font-size: 12px;
    bottom: 0px;
    position: absolute;
    width: -webkit-fill-available;
    height: 54px;
    background: var(--white);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14px 5px 10px 5px;
    border-radius: 0 0 5px 5px;

    .tabela-rodape--esquerda p {
        margin-bottom: none;
        color: var(--primary);
        margin-left: 10px;
        margin: auto;
    }

    .tabela-rodape--direita p {
        margin-bottom: none;
        color: var(--primary);
        margin-right: 10px;
    }

    .tabela-rodape--centralizado {
        color: var(--primary);
        padding-top: inherit;
    }
}

.condicao-ativo {
    color: var(--secondary-two);
}

.condicao-pendente {
    color: var(--car-pendente-color);
}

.condicao-suspenso {
    color: var(--car-suspenso-color);
}

.condicao-cancelado {
    color: var(--danger);
}
.abrindo-modal-cars {
    cursor: pointer;
}

.color-inforacao {
    font-weight: 500;
    display: flex;
    height: 17px;
    color: var(--blue);
    font-size: 14px;
    .el-icon-right.color-inforacao {
        font-size: 16px;
        &:before {
            margin-top: 3px;
        }
    }
    &:hover {
        text-decoration: none;
        color: #0256b1;
    }
}

.laranja {
    color: #f88342;
}
</style>
